import { ErrorHandler, inject, Injectable } from '@angular/core';
import { DatadogService } from 'src/app/services/data-dog.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private dataDogService = inject(DatadogService);

  public handleError(error: Error): void {
    console.error('An unhandled error occurred', error);

    try {
      this.dataDogService.error(error);
    } catch (dataDogError) {
      // Silently handle DatadogService errors to prevent cascading failures
      console.error('Failed to log error to DatadogService', dataDogError);
    }
  }
}
